<template>
  <div v-if="val"><slot v-bind:val="val"></slot></div>
  <span
    class="skeleton skeleton--line"
    :class="skeletonClass"
    :style="skeletonStyle"
    v-else
  />
</template>

<script>
export default {
  name: "SkeletonLine",
  props: {
    val: [Object, String],
    variant: String,
    width: String,
  },
  computed: {
    skeletonClass() {
      return this.variant === "light" ? "skeleton--light" : "";
    },
    skeletonStyle() {
      return this.width && `width: ${this.width}`;
    },
  },
};
</script>

<style lang="scss">
@keyframes pulse {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: -135% 0%;
  }
}

.skeleton {
  background-image: linear-gradient(
    -90deg,
    theme("colors.gray.600") 0%,
    theme("colors.gray.300") 50%,
    theme("colors.gray.600") 100%
  );
  animation: pulse 1.2s ease-in-out infinite;
  background-size: 400% 400%;
  display: block;
  width: 100%;
}

.skeleton--line {
  opacity: 0.4;
  width: 5.5em;

  &::before {
    content: "\00a0";
    visibility: hidden;
  }
}

.skeleton--light {
  background-image: linear-gradient(
    -90deg,
    theme("colors.gray.500") 0%,
    theme("colors.white") 50%,
    theme("colors.gray.500") 100%
  );
}
</style>
